import { JsonPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

@Component({
  selector: 'tellent-assistant-context-preview',
  imports: [JsonPipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <details>
      <summary>🔧 Context ({{ keyCount() }} keys)</summary>
      <pre class="json">{{ context() | json }}</pre>
    </details>
  `,
  styleUrls: ['./tellent-assistant-context-preview.component.less'],
})
export class TellentAssistantContextPreviewComponent {
  public readonly context = input.required<Record<string, unknown>>();
  protected readonly keyCount = computed(() => Object.keys(this.context()).length);
}
